import { ImperfectiveVerb, PerfectiveVerb } from '../../types'
import ёбнуть from './ёбнуть'
import ебать from './ебать'
import ебаться from './ебаться'
import ебашить from './ебашить'
import заебать from './заебать'
import пиздеть from './пиздеть'
import проебать from './проебать'
import спиздить from './спиздить'

const verbs: Array<ImperfectiveVerb | PerfectiveVerb> = [
  ебать,
  ебаться,
  ебашить,
  ёбнуть,
  заебать,
  пиздеть,
  проебать,
  спиздить,
]

export default verbs
